import styles from './MessageCard.module.scss'
import { motion } from "framer-motion";
export const MessageCard = ({
  message,
  variant = 'info',
  width100
  
}: {
  message?: string | null | undefined
  variant?: 'danger' | 'warring' | 'info'
  width100?: boolean
}): JSX.Element => {

  if (!message) {
    return <></>
  }

  return (

    <motion.div
    initial={{ transform: "scale(0.8)", opacity: 0.7 }}
    animate={{ transform: "scale(1)", opacity: 1 }}
    exit={{ transform: "scale(0.8)", opacity: 0.7}}
    transition={{
      type: "spring",
      duration: 0.3,
      stiffness: 260,
      damping: 20,
    }}
    style={
      {
        width: width100 ? '100%' : undefined
      }
    } className={[styles['error-message'], styles['error-message--' + variant]].join(' ')}>
      <p
        className={[styles['error-message__text'], styles['error-message__text--' + variant]].join(
          ' '
        )}
      >
        {message}
      </p>
    </motion.div>
  )
}

export default MessageCard
